App.ApplicationRoute = Em.Route.extend
  session:  Em.inject.service()
  realTime: Em.inject.service('realTime')
  orderMonitor: Em.inject.service('orderMonitor')

  ###
  # Загрузка текущего профиля
  ###
  beforeModel: (transition) ->
    Em.Logger.log 'Пытаемся загрузить текущего пользователя'

    new Em.RSVP.Promise (resolve, reject) =>
      @get('session').loadUser()
      .then (user) =>
        Em.Logger.log "Загрузили пользователя"
        user?.stat('loaded','init')
        resolve()
      , =>
        Em.Logger.log "Не нашли пользователя"
        resolve()

  activate: ->
    Em.$('.global-loading-overlay').hide(0)

    # Запускаем сервисы
    @get('orderMonitor')
    @get('realTime')
    @get('sip')

  actions:
    error: (error) ->
      @controllerFor('error')?.set('error', error)
      true

    logout: ->
      @get('session').logout()

    showSupportModal: (message) ->
      @set('supportModalMessage', message) if message?
      @get('controller').set('supportModalMessage', message)
      @get('controller').set('isSupportModalShown', true)

    closeSupportModal: ->
      @get('controller').set('isSupportModalShown', false)
      @get('controller').set('supportModalMessage', '')

    transitionTo: (path) ->
      if not Ember.isEmpty(path)
        @transitionTo(path)
